import React, { useState } from 'react'

import { MoreHorizontal, MoreVertical } from 'lucide-react'

import { buttonVariants } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'

interface Props {
	children?: (args: { onClick: () => void }) => JSX.Element
	vertical?: boolean
}

const AstaKebabMenu: React.FC<Props> = ({ children, vertical = true }) => {
	const [open, setOpen] = useState(false)

	const handleClose = () => {
		setOpen(false)
	}

	return (
		<DropdownMenu open={open} onOpenChange={setOpen}>
			<DropdownMenuTrigger
				className={cn(
					buttonVariants({ variant: 'ghost', size: 'icon' }),
					'h-8 w-8 p-0'
				)}
				id="asta-kebab-menu"
			>
				{vertical ? (
					<MoreVertical className="h-4 w-4" />
				) : (
					<MoreHorizontal className="h-4 w-4" />
				)}
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{children && children({ onClick: handleClose })}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}

export default AstaKebabMenu
